<template>
  <!--  找工作卡片组件  -->
  <div class="find-job-card g-full-width">
    <div class="g-p-20" @click="goDetail(item.id)">
      <div class="g-flex g-row-between">
        <div class="g-text-left">
          <p class="main-text g-font-weight-6 g-font-20">{{item.postName}}</p>
          <div class="g-flex g-m-t-10 g-row-center remark-text g-font-14 tag">
            <p>{{item.qualifications}}</p>
            <p class="g-p-l-10 g-p-r-10">|</p>
            <p>{{item.workYear}}年经验</p>
            <p class="g-p-l-10 g-p-r-10">|</p>
            <p>{{item.num}}人</p>
          </div>
        </div>
        <div class="g-text-right">
          <p class="g-font-22 yellow-text g-weight-font">{{item.salary}}</p>
          <p class="g-m-t-7 g-font-14 remark-text" style="letter-spacing: 2px">{{item.countyName}}</p>
        </div>
      </div>
      <div class="line"></div>
      <div class="g-flex g-row-between">
        <div class="g-flex g-font-14">
          <div class="g-flex">
            <img src="@/assets/find-job/store-icon.png" class="icons" alt="">
            <p class="g-m-l-10 remark-text">{{item.clinicName}}</p>
          </div>
          <div class="g-flex g-m-l-30">
            <img src="@/assets/find-job/create-time-icon.png" class="icons" alt="">
            <p class="g-m-l-10 remark-text">发布时间：{{item.createTime}}</p>
          </div>
        </div>
        <div class="submit-btn g-flex-right g-font-14 g-flex g-row-center" @click.stop="showResume" v-if="item.resumeId==-1">
          投递简历
        </div>
      </div>
    </div>
  </div>
</template>

<script>
	import {
		sendResume
	} from "@/api/job.js"
export default {
  name: "find-job-card",
  props:['item'],
  data(){
    return{

    }
  },
  computed: {
	isCustomer() {
	  	return this.$store.state.isLogin && (this.$store.state.userInfo.clinic_id == '' || this.$store.state.userInfo.clinic_id == -1)
	},
  	getUserRole() {
  		return this.$store.state.userInfo.role_name
  	}
  },
  mounted() {
  	console.log(this.item)
  },
  methods:{
    goDetail(id){
      this.$router.push({
        path: 'job-detail',
		query:{id:id}
      })
    },
    // 点击投递简历
    showResume(){
		if(!this.$store.state.isLogin) {
			this.$router.push({name:'login'});
		} else if(this.$store.state.userInfo.resumeId==-1) {
			this.$message.warning('请先完善个人简历信息');
			this.$router.push({name:'mine',query:{menuIndex:2}});
		} else {
			let params={
				orgId:this.item.clinicId,
				orgName:this.item.clinicName,
				employPostId:this.item.postId,
				employPostName:this.item.postName,
				type:0,
				status: 0
			}
			sendResume(params).then(res=>{
				 this.$emit('showResume',{id:1})
			})
		}
    }
  }
}
</script>

<style lang="scss" scoped>
  .find-job-card{
    background: #fff;
    border-radius: 5px;

    .line{
      width: 100%;
      height: 1px;
      background: #F7F7F7;
      margin: 18px 0;
    }
  }

  .icons{
    width: 22px;
    height: 22px;
  }

  .submit-btn{
    padding: 8px 30px;
    margin-right: 0;
    margin-left: 30px;
  }
</style>